
import {
  Component, EventEmitter, Input, OnInit, Output, ViewChild
} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { PassportService } from '../../../services/passport.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css', '../profile.component.css'],
})
export class EditComponent implements OnInit {
  @Input('profile') profile: any;
  @Output('editProfile') editProfile = new EventEmitter<any>();

  @ViewChild('f') userForm;

  public firstName: string;
  public lastName: string;
  public bio: string;
  public selectedFavouritesIDs: Array<number> = [];

  public profileImageName: string;
  public profileImageFile: File;
  public profileImageRaw: string;

 constructor(private passportService: PassportService, private spinner: NgxSpinnerService) {}

  ngOnInit(): void {
    this.initialise();
  }

  initialise(): void {
    const { profile } = this;
    this.firstName = profile.firstName;
    this.lastName = profile.lastName;
    this.bio = profile.bio;
  }

  updateProfileImageFile(event: any): void {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file: File = event.target.files[0];

      this.profileImageName = file.name;
      this.profileImageFile = file;

      reader.readAsDataURL(file);
      reader.onload = () => {
        this.profileImageRaw = reader.result as string;
      };
    }
  }

  handleSaveProfile(): void {
    const request = {
      ...this.userForm.form.value,
      favourites: this.profile.favourites,
    };
    this.updatePassportProfile(request);
  }

  handleCancel(): void {
    this.editProfile.emit({
      value: 'cancel-edit'
    });
  }

  updatePassportProfile(request: any): void {
    this.spinner.show();
    this.passportService.updateData(request).then((profile: any) => {
      const data = {
        value: 'save-profile',
        profile
      };

      this.passportService.updateProfilePic(this.profile.userId, this.profileImageName, this.profileImageFile)
        .then(() => {
          console.log('profile pic updated successfully');
          this.spinner.hide();
          this.editProfile.emit(data);
        })
        .catch(err => {
          console.error(err);
          this.spinner.hide();
          this.editProfile.emit(data);
        });
    });
  }

  getProfilePic(): string {
    return this.profileImageRaw || this.profile.userImageUrl || environment.apiURL + '/images/MyProfile/user-icon-1 (4).png';
  }
}
